import {Store} from './types';

export class StoreExpiredEvent<T> {
	constructor(public store: string | (() => Store<T>)) {
	}
}